<div class="modal-header">
  <h5 class="modal-title" i18n="@@EditPricingHeader">Tarif bearbeiten</h5>
  <button type="button" id="x_close" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="form" (ngSubmit)="updatePricing()" *ngIf="formReady">
    <div class="form-group mb-2">
      <label for="name" i18n="@@NameLabel">Name</label>
      <input type="text" id="name" formControlName="name" class="form-control" placeholder="Name" i18n-placeholder="@@Name" ngbAutoFocus />
    </div>

    <div class="form-group mb-2">
      <label for="description" i18n="@@DescriptionLabel">Beschreibung</label>
      <textarea type="text" id="description" formControlName="description" class="form-control"
        placeholder="Beschreibung" i18n-placeholder="@@Description" rows="3"></textarea>
    </div>

    <div class="form-group mb-2">
      <label for="price"
        i18n-ngbTooltip="@@PriceNotEditableWarningTooltip"
        ngbTooltip="Bitte beachten Sie, dass eine nachträgliche Änderung des Preises nicht möglich ist,
        da dieser Gegenstand von Rechnungen wird. Sie können stattdessen Tarife austauschen.">
        Euro pro Kilowattstunde (kWh)*</label>
      <div class="d-flex gap-1" id="prices">
        <div class="d-flex">
          <input type="text" value="AC" disabled>
          <input id="price"
            type="text"
            mask="0,00"
            [showMaskTyped]="true"
            prefix="€ "
            formControlName="price"
            class="form-control"
            disabled
            placeholder="für Laden mit AC" />
        </div>
        <div class="d-flex">
          <input type="text" value="DC" disabled
            i18n-ngbTooltip="@@PriceDcInfo"
            ngbTooltip="Laden über DC ist in der Regel teurer als Laden über AC, weil die Belastung für das Netz größer ist.">
          <input id="priceDc"
            type="text"
            mask="0,00"
            [showMaskTyped]="true"
            prefix="€ "
            formControlName="priceDc"
            class="form-control"
            disabled
            placeholder="für Laden mit DC" />
        </div>
      </div>
    </div>

    <div class="form-group mb-2" *ngIf="!pricing.isPublic">
      <label i18n="@@UsersWithThisPricingLabel">Benutzer mit diesem Tarif</label>
      <ng-select *ngIf="preselectedUsers.length > 0 || availableUsers.length > 0; else noUsersAvailable"
        [items]="availableUsers"
        id="user"
        [placeholder]="usersSelectPlaceholder"
        multiple="true"
        [closeOnSelect]="false" 
        [clearSearchOnAdd]="true"
        [hideSelected]="true"
        appendTo="body"
        bindLabel="fullName"
        notFoundText="Keine Benutzer vorhanden"
        formControlName="preselectedUsers">
      </ng-select>
      <ng-template #noUsersAvailable>
        <input disabled [placeholder]="usersSelectPlaceholder" class="form-control">
      </ng-template>
    </div>
  </form>
</div>

<div class="modal-footer">
  <div class="float-end">
    <button type="button" id="cancel" class="btn btn-yellow text-white me-2" data-bs-dismiss="modal" (click)="close()" i18n="@@CancelButton">
      Abbrechen
    </button>
    <button type="button" id="save" class="btn btn-save" data-bs-dismiss="modal" (click)="updatePricing()" i18n="@@SaveButton" [disabled]="isSupporter">
      Änderungen speichern
    </button>
  </div>
</div>
